import { getAssetPath } from '@stencil/core';
import log from 'loglevel';
import { Config } from '../model/config';

export const fetchDefaultConfig = async (): Promise<Config> => {
  const newLocal = getAssetPath('../assets/config.json');
  const res: Response | void = await fetch(newLocal).catch(err => {
    log.error('oiam-oauth-wc: failed to fetch config', err);
  });
  if (res && res.ok) {
    try {
      const json = await res.json();
      log.debug('oiam-oauth-wc: defaultConfig eingelesen', json);
      return json;
    } catch (e) {
      log.error('Failed to read config file', e);
      return fallbackConfig();
    }
  } else {
    log.error('Loaded default config failed somehow, will run with Prod defaults', res ? res.status : 'void');
    return fallbackConfig();
  }
};

export const fallbackConfig = (): Config => {
  const u = new URL(window.location.href);
  switch (u.hostname) {
    case 'localhost':
    case 'web.dev.ocp.webapp.idst.ibaintern.de':
      log.info(
        'oiam-oauth-wc: FallbackComponent: nonProd environment detected, selecting main/S-INT as fallback target',
      );
      return fallbackConfigMain();
    default:
      log.info('oiam-oauth-wc: FallbackComponent: selecting prod as fallback target');
      return fallbackConfigProd();
  }
};

export const fallbackConfigProd = (): Config => {
  const config: Config = new Config();
  config.authority = 'https://sso.arbeitsagentur.de/auth/realms/OCP';
  config.profileSelectionRedirectUrls = {
    default: {
      profilanlage: {
        'urn:bafor:step:person:':
          'https://web.arbeitsagentur.de/kusos/stokure-webcomponents/?redirect-to=${CALLBACKURL}',
        'urn:bafor:kiwi:': 'https://web.arbeitsagentur.de/kostaf/fallzuordnung/start?redirect-to=${CALLBACKURL}',
        'urn:bafor:step:betrieb:': 'https://web.arbeitsagentur.de/portal/kontakt/de/unternehmen/unternehmensanfrage',
        'urn:bafor:pmventerprise:': 'https://web.arbeitsagentur.de/TODO/hinweisAufPmve',
      },
      baidmatch: {
        'urn:bafor:kiwi:':
          'https://web.arbeitsagentur.de/kostaf/fallzuordnung/identitaet?identity=${IDENTITY}&fallnr=${ACTING_ON_BEHALF_OF}&redirect-to=${CALLBACKURL}',
        'urn:bafor:step:person:':
          'https://web.arbeitsagentur.de/kusos/bsi-service/?identity=${IDENTITY}&acting-on-behalf-of=${ACTING_ON_BEHALF_OF}&redirect-to=${CALLBACKURL}',
      },
      freischaltung:
        'https://web.arbeitsagentur.de/oiambk/oiambk-freischaltcode-einloesen-ui/freischaltcode?redirect-to=${CALLBACKURL}',
      profilonline: 'https://web.arbeitsagentur.de/profil/profil-ui/pd/?acting-on-behalf-of=${ACTING_ON_BEHALF_OF}',
    },
  };
  config.devmode = false;
  config.logLevel = 'info';
  return config;
};

export const fallbackConfigMain = (): Config => {
  const config: Config = new Config();
  config.authority = 'https://sso.dev.ocp.webapp.idst.ibaintern.de/auth/realms/OCP';
  config.profileSelectionRedirectUrls = {
    default: {
      profilanlage: {
        'urn:bafor:step:person:':
          'https://web.dev.ocp.webapp.idst.ibaintern.de/kusos-sint/stokure-webcomponents?redirect-to=${CALLBACKURL}',
        'urn:bafor:kiwi:':
          'https://web.dev.ocp.webapp.idst.ibaintern.de/kostaf/fallzuordnung/sint/start?redirect-to=${CALLBACKURL}',
        'urn:bafor:step:betrieb:': 'https://web.arbeitsagentur.de/portal/kontakt/de/unternehmen/unternehmensanfrage',
        'urn:bafor:pmventerprise:':
          'https://web.dev.ocp.webapp.idst.ibaintern.de/TODO/zur/authority/passende/url/hinweisAufPmve',
      },
      baidmatch: {
        'urn:bafor:kiwi:':
          'https://web.dev.ocp.webapp.idst.ibaintern.de/kostaf/fallzuordnung/sint/identitaet?identity=${IDENTITY}&acting-on-behalf-of=${ACTING_ON_BEHALF_OF}&redirect-to=${CALLBACKURL}',
        'urn:bafor:step:person:':
          'https://web.dev.ocp.webapp.idst.ibaintern.de/kusos-sint/bsi-service/?identity=${IDENTITY}&acting-on-behalf-of=${ACTING_ON_BEHALF_OF}&redirect-to=${CALLBACKURL}',
      },
      freischaltung:
        'https://web.dev.ocp.webapp.idst.ibaintern.de/oiambk-sint/oiambk-freischaltcode-einloesen-ui/freischaltcode?redirect-to=${CALLBACKURL}',
      profilonline:
        'https://web.dev.ocp.webapp.idst.ibaintern.de/profil-sint/profil-ui/pd/?acting-on-behalf-of=${ACTING_ON_BEHALF_OF}',
    },
  };
  config.devmode = false;
  config.logLevel = 'info';
  return config;
};
